<template>
  <div class="navMargin">
    <NavBar :scroll-padding="true" :transparent-on-top="true" :search-button="false"></NavBar>
    <header class="fondo">
      <vs-row>
        <vs-col w="6" sm="12" xs="12">
          <h1>Resultados para «{{ this.$route.query.q }}»</h1>
        </vs-col>
        <vs-col w="6" sm="12" xs="12" class="search-bar-container">
          <vs-input
              primary
              v-model="query"
              :value="query"
              :label-placeholder="$t('search.search_bar_placeholder')"
              @keyup.enter="fetchNewResults"
              icon-after
              @click-icon="fetchNewResults"
          >
            <template #icon>
              <i class='bx bx-search'></i>
            </template>
          </vs-input>
        </vs-col>
      </vs-row>
    </header>
    <vs-row class="results-container">
      <vs-col w="12" v-if="results.tv.length > 0" class="section-title-col"><b class="section-title"> <i class='bx pad bx-tv'></i> Shows encontrados</b></vs-col>
      <vs-card-group v-if="results.tv.length > 0" class="remove-scroll" w="12">
        <div v-for="show in results.tv" :key="show.id">
          <vs-card @click="openShowInfo(null, show.name, show.url)" class="force-aspect-ratio" type="4"> <!-- goToLink(`https://videnti.co/watch/${show.url}`) -->
            <template #title>
              <h3 class="episode-name-cut-legacy">{{show.name}}</h3>
            </template>
            <template #img>
              <!-- <img v-if="show.poster_horizontal != null || show.poster_horizontal === ''" :src="show.poster_horizontal" alt="" width="1080px"><img v-else :src="`https://i.imgur.com/Zx6wTMp.png`" alt="" width="1080px"> -->
              <img :src="show.poster_horizontal" alt="" @error="imageUrlAlt" width="1080px">
            </template>
            <template #text><p></p></template>
          </vs-card>
        </div>
      </vs-card-group>

      <vs-col w="12" v-if="results.book.length > 0" class="section-title-col"><b class="section-title"> <i class='bx pad bx-book'></i> Libros encontrados</b></vs-col>
      <vs-card-group v-if="results.book.length > 0" class="remove-scroll" w="12">
        <div class="colMargin" v-for="book in results.book" :key="book.id">
          <vs-card type="2" @click="openShowInfo('book', book.name, book.url)" class="landingCard">
            <template #title> <b>{{ book.name }}</b> </template>
            <template #img> <img :src="book.poster_vertical" alt=""> </template>
            <template #text> <p></p> </template>
          </vs-card>
        </div>
      </vs-card-group>

      <vs-col w="12"             v-if="results.tv_episode.length > 0" class="section-title-col"><b class="section-title"> <i class='bx pad bxs-tv'></i> Episodios encontrados</b></vs-col>
      <EpisodesCardsSingleSeason v-if="results.tv_episode.length > 0" :episodes="results.tv_episode" :show-season-number="true" :open-show-info="openShowInfo" ></EpisodesCardsSingleSeason>
    </vs-row>

    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import NavBar from "../components/NavBar";
import Footer from "./Footer";
import EpisodesCardsSingleSeason from "../components/EpisodesCardsSingleSeason";

export default {
  name: "Search",
  components: {EpisodesCardsSingleSeason, Footer, NavBar },
  methods: {
    async fetchResults() {
      await axios
          .get('https://api.videnti.co/search_v2?q=' + this.query + '&type=tv')
          .then(res => {
            this.results.tv = res.data;
            this.results.tv.forEach(show => {
              show.poster_horizontal = this.getImageSource(show.images, 'poster_horizontal', 'sm', show.poster_horizontal)
              show.poster_vertical = this.getImageSource(show.images, 'poster_vertical', 'sm', show.poster_vertical)
            });
          }).catch(err => this.showAlertError(err))
      await axios
          .get('https://api.videnti.co/search_v2?q=' + this.query + '&type=book')
          .then(res => {
            this.results.book = res.data;
          }).catch(err => this.showAlertError(err))
      await axios
          .get('https://api.videnti.co/search_v2?q=' + this.query + '&type=tv_episode')
          .then(res => {
            this.results.tv_episode = res.data;
          }).catch(err => this.showAlertError(err))
    },
    fetchNewResults() {
      this.$router.replace({ path: this.$route.path, query: { q: this.query } });
      this.fetchResults();
    },
    openShowInfo(type, name, url) {
      switch (type) {
        case "tv":
        default:
          this.$router.push({ name: "animedetail", params: { name: url } })
          break;
        case "book":
          this.$router.push({ name: "lectoremdetail", params: { titulo: url } })
          break;
      }
    },
    showAlertError(error) {
      if (error.response) {
        switch (error.response.status) {
          case 400:
            this.$vs.notification({
              progress: 'auto',
              color: "danger",
              duration: "6000",
              title: '¡Ocurrió un error!',
              text: error.response.data.message ? error.response.data.message : "Ocurrió un error intentando enviar esta consulta."
            });
            break;
          case 500:
            this.$vs.notification({
              progress: 'auto',
              color: "danger",
              duration: "6000",
              title: '¡Ocurrió un error interno!',
              text: error.response.data.message ? error.response.data.message : "Lo sentimos, ocurrió un error de parte nuestra. Por favor, vuelve a intentarlo más adelante."
            });
        }
      }
    },
    imageUrlAlt(event, tall) {
      if (tall) {
        event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_y.png"
      } else {
        event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png"
      }
      // event.target.src = "https://i.imgur.com/Zx6wTMp.png"
    }
  },
  data() {
    return {
      query: "",
      results: {
        tv: {},
        book: {},
        tv_episode: {}
      }
    }
  },
  async created() {
    this.query = this.$route.query.q;
    await this.fetchResults();
  },
  metaInfo() {
    return {
      title: this.$route.query.q,
      titleTemplate: '%s - Buscar en Videnti',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf8' },
        { name: 'robots', content: 'noindex' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.results-container {
  width: auto;
  margin: 0 10px;
}

.section-title-col {
  margin: {
    top: 1.5rem;
  }
}

.bx.pad {
  padding-right: 20px;
}

.search-bar-container {
  display: flex;
  justify-content: center;
  align-self: center;
}

header {
  padding-top: 10px;
  padding-left: 2%;
  padding-right: 2%;
  display: block;
}

.fondo {
  background-color: rgba(0, 0, 0, 0.686);
  background-image: url(../assets/bg_inicio.png);
  background-size: cover;
  background-blend-mode: overlay;
}
</style>
